/**
 * WandIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const WandIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#a)">
      <path d="m23.5.5-2.65 1.452L18.197.5l1.455 2.645-1.455 2.645 2.651-1.452L23.5 5.79l-1.445-2.645zm-2.65 14.389-2.652-1.452 1.455 2.645-1.455 2.645 2.651-1.442 2.651 1.442-1.445-2.645 1.445-2.645zM8.034 4.338l2.65 1.452L9.23 3.145 10.685.5 8.034 1.952 5.383.5l1.445 2.645L5.383 5.79zm7.683 1.939a2.13 2.13 0 0 0-1.515-.626c-.578 0-1.116.219-1.514.626L1.128 17.812a2.145 2.145 0 0 0 0 3.033l2.033 2.029c.408.407.946.626 1.514.626.578 0 1.117-.219 1.515-.626l11.56-11.535a2.145 2.145 0 0 0 0-3.033zm.618 3.65-2.78 2.774-2.243-2.237 2.78-2.785s.08-.05.11-.05.07 0 .11.05l2.033 2.029c.06.06.06.16 0 .219z" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const WandIcon = makeIcon('WandIcon', WandIconSvg)
